// Prices come from the backend as decimal strings ("40.00"). Whole rands read
// better without the cents, so R40 rather than R40.00.
export const formatPrice = (price) => {
  const value = Number(price);
  return `R${Number.isInteger(value) ? value : value.toFixed(2)}`;
};
